// extracted by mini-css-extract-plugin
export default {"badge":"MultiToken_badge__eDKQ+"};